export enum ComplexDataTypesEnum {
    License = 0,
    User = 1,
    Reseller = 2,
    Industry = 3
}
